import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';
import './theme/fonts.css';
import './theme/global.css';

import { App } from './app/App';
import { captureUtm } from './lib/utm';

/* Метки ссылки, по которой пришли, — до того, как маршрутизатор сменит адрес. */
captureUtm();

const container = document.getElementById('root');
if (!container) throw new Error('Не найден корневой элемент #root');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
